/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Context for holding react router routes
 */

import { createContext } from 'react'
import { type ZumperRoute } from './types'

/**
 * @deprecated Remove once withRouter is no longer used.
 */
export const RoutesContext = createContext<ZumperRoute[]>([])
